import transformStore from './transform'
import settings from '../../../components/settings'
import { appBasePath } from '../../../../utils/appBasePath'
import { clearState } from '../../../../utils/state'

const reloadOnError = (storeData, stores = []) => {
  const storeId = storeData?.variables?.storeId || 0
  if (!storeData) {
    return undefined
  }

  if (storeData.error && storeId) {
    /* eslint-disable no-console */
    console.warn(`Failed to fetch store. Clearing state.`)
    clearState(settings.brand)
    window.location = appBasePath
    return undefined
  }

  if (storeData.store) {
    const selectedStore = stores
      .filter(
        (item) =>
          item.store.id === storeId &&
          !settings.excludedStudioTypes.includes(item.store.storeType)
      )
      .at(0)

    return selectedStore && transformStore(selectedStore)
  }

  return undefined
}

const badaPropsChange = ({
  stores,
  StoreWithDistance,
  overrideMeetingType,
}) => ({
  store: reloadOnError(StoreWithDistance, stores),
  stores: stores
    ?.filter((storeItem) => storeItem.store.externalMeetingData.acceptMeetings)
    ?.filter(
      (storeItem) =>
        !settings.excludedStudioTypes.includes(storeItem.store.storeType)
    )
    ?.map(transformStore),
  overrideMeetingType,
})

export default badaPropsChange
